import { useLanguage } from "@/contexts/LanguageContext";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface SDGSectionProps {
  centered?: boolean;
}

const SDGSection = ({ centered = false }: SDGSectionProps) => {
  const { t } = useLanguage();

  const sdgs = [
    {
      iconUrl: t("dashboard.sdg.sdg13.icon"),
      description: t("dashboard.sdg.sdg13.description"),
    },
    {
      iconUrl: t("dashboard.sdg.sdg15.icon"),
      description: t("dashboard.sdg.sdg15.description"),
    },
  ];

  return (
    <div className="mt-4">
      <div
        className={`flex gap-2 mb-3 ${
          centered ? "justify-center" : "justify-start"
        }`}
      >
        {sdgs.map((sdg, index) => (
          <TooltipProvider key={index} delayDuration={100}>
            <Tooltip>
              <TooltipTrigger asChild>
                <img
                  src={sdg.iconUrl}
                  alt=""
                  className="w-12 h-12 rounded-lg"
                />
              </TooltipTrigger>
              <TooltipContent className="max-w-xs text-sm">
                <p>{sdg.description}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ))}
      </div>
      <h2 className={`text-gray-600 text-sm ${centered ? "text-center" : ""}`}>
        {t("dashboard.sdg.title")}
      </h2>
    </div>
  );
};

export default SDGSection;
